<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="bk-title">The Problems of Philosophy</p>
<p class="authorname">Bertrand Russell</p>
<p class="publisher"><img alt="image" src="image/phil_01.jpg"/></p>
<p class="center"><b>PHILOSOPHICAL LIBRARY</b></p>
<p class="center"><b>New York</b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1.vue?2f9fbf28